<template>
    <div class="module-wa-autosender">
        <SOSlotBase :container-name="'connect-perangkat'" :bg-grey="true">
            <template v-slot:content>
                <div class="f-14 f-c-black f-regular m-t--50">
                    <div class="logo-smartlnk">
                        <IconBased :width="209" :height="60">
                            <template v-slot:icons>
                                <SmartlinkLogo/>
                            </template>
                        </IconBased>
                    </div>
                    <div class="web-view" style="text-align: center;" v-if="isConnected">
                        <div class="connected-device d-flex justify-content-center align-items-center">
                            <div style="text-align: center;">
                                <IconBased :width="90" :height="90">
                                    <template v-slot:icons>
                                        <CheckedCircleBlueBig/>
                                    </template>
                                </IconBased>

                                <label class="m-d-0 p-t-16" style="display: block;">Perangkat Sudah Terhubung! <br/>
                                    Silahkan Tes Kirim Pesan Melalui Aplikasi Smartowner</label>
                            </div>
                        </div>
                    </div>
                    <div class="web-view" v-else-if="needUpdateWA==='yes'">
                        <div class="wa-qrcode">
                            <div class="qr-head f-14 f-regular f-c-black m-d-16">
                                <label class="m-d-0 " style="color: #ff0099;border: solid 1px;padding: 2px;">
                                    Lakukan update aplikasi whatsapp yang terbaru di perangkat anda, <br/>bila sudah
                                    update, klik tombol generate qr ulang dibawah ini.
                                </label>
                            </div>
                            <div style="text-align: center">
                                <SOButton
                                        :outline="true"
                                        :text="'Generate Ulang'"
                                        :id="`generate-qr-ulang`"
                                        @action="showMultiModal"
                                />

                            </div>

                        </div>
                    </div>
                    <div class="web-view" v-else>
                        <div class="wa-qrcode" v-if="isOnSyncData">
                            <div class="qr-head f-18 f-bold f-c-black m-d-16">
                                <label class="m-d-0 " style="color: #214264;">
                                    <div style="text-align: center;">
                                        Scan Perangkat Berhasil
                                        <br/>
                                        <img
                                                src="@/assets/img/whatsapp_linked_multiple.png"
                                                alt="" class="img-whatsapp-multi">
                                        <div>
                                        <span
                                                class="spinner-border f-c-blue"
                                                role="status"
                                                aria-hidden="true"></span>
                                            <br/>
                                            Mohon tunggu sekitar 30 Detik, <br/>Sedang sinkronisasi data ...
                                        </div>
                                    </div>

                                </label>

                            </div>
                        </div>
                        <div class="wa-qrcode" v-else>
                            <div class="qr-head f-16 f-regular f-c-black m-d-16" v-if="!qr && !isNeedReload">
                                <p class="m-d-0" v-if="!generate">Mohon tunggu sedang generate QRCode</p>
                                <p class="m-d-0" v-if="!generate">
                                    Anda dapat generate ulang dalam <span id="countdown-qr"></span>
                                </p>
                                <p class="m-d-0" v-else>Waktu Habis, Klik Tombol Generate Ulang Dibawah Ini</p>

                                <SOButton
                                        :outline="true"
                                        :text="'Generate Ulang'"
                                        :id="`generate-qr`"
                                        @action="doGenerate"
                                        :disable="!generate"
                                />
                            </div>
                            <div class="qr-head f-18 f-bold f-c-black m-d-16" v-else>
                                <label class="m-d-0">Scan menggunakan <span v-if="getMulti">Aplikasi WA Terbaru</span>
                                </label>
                                <label class="m-d-0">Dengan Nomor +{{ getNomor }} </label>
                            </div>

                            <div class="qr-body">
                                <div
                                        class="d-flex justify-content-center align-items-center"
                                        v-if="!qr && isFetching && !generate"
                                        style="height:300px;"
                                >
                                    <span class="spinner-border f-c-blue" role="status" aria-hidden="true"></span>
                                </div>
                                <div
                                        v-if="isNeedReload"
                                        style="height:300px;"
                                        class="d-flex justify-content-center align-items-center"
                                        @click="loadQr"
                                >
                                    <div style="text-align: center;">
                                        <div class="f-c-red m-d-16" v-if="eMsg">
                                            {{ eMsg }}
                                        </div>
                                        <IconBased :width="30" :height="30">
                                            <template v-slot:icons>
                                                <Refresh/>
                                            </template>
                                        </IconBased>
                                        <div class="m-t-8 f-c-blue">Klik untuk memuat ulang kode QR</div>
                                    </div>
                                </div>
                                <div v-if="qr && !isFetching && !isNeedReload">
                                    <VueQr :text="qr" :size="250" color="#206CFF" bg-color="#ffffff" error-level="L">
                                    </VueQr>
                                </div>
                            </div>
                        </div>
                        <div class="bg-white p-x-20 m-d-16 m-t-16 wa-instruction-web">
                            <div class="f-14 f-regular f-c-black m-d-16 p-t-16">
                                <label class="m-d-0">Untuk scan QR Code, ikuti instruksi:</label>
                            </div>
                            <div class="m-d-16">
                                <CoInstruction/>
                            </div>
                            <div class="m-d-16 f-12 f-c-midgrey f-regular">
                                <label class="m-d-0">
                                    Mohon untuk tidak mengambil screenshot di halaman ini, karena QR Code bersifat
                                    dinamis (selalu berganti setiap saat)
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="bg-white p-x-20 m-d-16 m-t-16 wa-instruction-m" v-if="!isConnected">
                        <div class="f-14 f-regular f-c-black m-d-16 p-t-16">
                            <label class="m-d-0">Untuk scan QR Code, ikuti instruksi:</label>
                        </div>
                        <div class="m-d-16">
                            <CoInstruction/>
                        </div>
                        <div class="m-d-16 f-12 f-c-midgrey f-regular">
                            <label class="m-d-0">
                                Mohon untuk tidak mengambil screenshot di halaman ini, karena QR Code bersifat dinamis
                                (selalu berganti setiap saat)
                            </label>
                        </div>
                    </div>
                </div>
            </template>
        </SOSlotBase>
    </div>
</template>
<script>
    import VueQr from "vue-qr-generator";
    import {mapGetters, mapActions} from "vuex";

    import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
    import SOButton from "@/so-components/global/ui/SOButton";

    import CoInstruction from "../../components/CoInstruction.vue";
    import IconBased from "../../components/iconPack/IconBased.vue";
    import Refresh from "../../components/iconPack/Refresh.vue";
    import SmartlinkLogo from "../../components/iconPack/SmartlinkLogo.vue";
    import CheckedCircleBlueBig from "../../components/iconPack/CheckedCircleBlueBig.vue";

    import {moduleName} from "../../store/state";

    export default {
        name: "WebSite",
        components: {
            VueQr,
            SOSlotBase,
            SOButton,
            CoInstruction,
            IconBased,
            Refresh,
            SmartlinkLogo,
            CheckedCircleBlueBig,
        },
        beforeRouteLeave(to, from, next) {
            this.unsubcribeQR();
            next();
        },
        data() {
            return {
                isOnSyncData: false,
                isNeedReload: false,
                isConnected: false,
                eMsg: "",
                generate: false,
            };
        },
        mounted() {
            this.init();
        },
        watch: {
            response: function (newRes, oldRes) {
                if (newRes.success) {
                    this.subcribeQR();
                    if (!this.qr) {
                        this.setFetching(true);
                    } else {
                        this.setFetching(false);
                    }
                }
            },
            eMsg: function (newMsg, oldMsg) {
                if (newMsg !== oldMsg && newMsg) {
                    this.$toast.error(newMsg);
                }
            },
            dataDeviceTiny: function (dataDeviceTiny) {
                if (dataDeviceTiny.status === 1) {
                    this.isConnected = true;
                } else {
                    if (this.autogenerateChanged >= 1) {
                        this.doGenerate();
                        console.log("generate.");
                    } else if (this.getMulti <= 0) {
                        this.showMultiModal()
                    } else {
                        this.doGenerate();
                        console.log("generate");
                    }

                }
            }
        },
        sockets: {
            connect: () => {
                console.log("soket konek");
            },
        },
        computed: {
            ...mapGetters(moduleName, {
                qr: "qr",
                dataDeviceTiny: "dataDeviceTiny",
                response: "response",
                isFetching: "isFetching",
            }),
            getDeviceId() {
                return this.$route.params.id_device;
            },
            getNomor() {
                return `${this.dataDeviceTiny.country_code}${this.dataDeviceTiny.number}`;
            },
            getMulti() {
                if (this.$route.query.multiperangkat !== undefined) {
                    return this.$route.query.multiperangkat
                }
                return `${this.dataDeviceTiny.multi}`;
            },
            autogenerateChanged() {
                return this.$route.query.autogenerate
            },
            needUpdateWA() {
                return this.$route.query.needUpdateWA
            }

        },
        methods: {
            ...mapActions({
                createQr: `${moduleName}/createQr`,
                setQr: `${moduleName}/setQr`,
                setFetching: `${moduleName}/setFetching`,
                getDetailTinyDevice: `${moduleName}/getDetailTinyDevice`,
                setIsconnectDevice: `${moduleName}/setIsconnectDevice`,
            }),
            async subcribeQR() {
                await this.sockets.subscribe(`whatsapp.deployment.up.${this.getDeviceId.toLowerCase()}`, (msg) => {
                    // alert(msg);
                });

                await this.sockets.subscribe(`whatsapp.login.qr.${this.getDeviceId.toLowerCase()}`, (qr) => {
                    this.setQr(qr);
                    this.setFetching(false);
                });
                await this.sockets.subscribe(`whatsapp.login.status.${this.getDeviceId.toLowerCase()}`, (isLogin) => {
                    this.isOnSyncData = false;

                    if (isLogin === "true") {
                        this.isConnected = true;
                        this.setIsconnectDevice({
                            iddevice: this.getDeviceId,
                            status: 1,
                            dbreadonly: this.$route.query.readonly,
                            multi:1,
                        });
                    }
                    if (isLogin === "PhoneNumberNotMatch") {
                        this.eMsg = `Gagal, Gunakan perangkat yang memiliki WA dengan Nomor +${this.getNomor} untuk scan.`;
                        this.isNeedReload = true;
                    } else if (isLogin === "QrTimeOut") {
                        this.eMsg = `Waktu Menampilkan QRCode telah habis.`;
                        this.isNeedReload = true;
                    } else if (isLogin === "PairSuccess") {
                        this.eMsg = "";
                        this.isOnSyncData = true;
                    } else if (isLogin === "ScannedByBeta") {
                        this.eMsg = `Gagal. Anda terdeteksi melakukan scan dengan Whatsapp Versi terbaru Multi-device.`;
                        this.isNeedReload = true;
                    } else if (isLogin === "ScannedByNotMultidevice") {
                        this.eMsg = `Gagal. Anda terdeteksi melakukan scan dengan Whatsapp Versi Lama.`;
                        this.isNeedReload = true;
                    } else {
                        this.isNeedReload = true;
                    }
                });
            },
            async unsubcribeQR() {
                await this.sockets.unsubscribe(`whatsapp.login.qr.${this.getDeviceId}`);
                await this.sockets.unsubscribe(`whatsapp.login.status.${this.getDeviceId}`);
                await this.sockets.unsubscribe(`whatsapp.deployment.up.${this.getDeviceId}`);
            },
            async init() {
                if (!this.dataDeviceTiny.number) {
                    this.getDetailTinyDevice({id_mesin: this.getDeviceId, dbreadonly: this.$route.query.readonly});
                    // execute on watch dataDeviceTiny
                } else if (this.dataDeviceTiny.status === 1) {
                    this.isConnected = true;
                } else {

                    if (this.autogenerateChanged >= 1) {
                        this.doGenerate();
                        console.log("generate.");
                    } else if (this.getMulti <= 0) {
                        this.showMultiModal()
                    } else {
                        this.doGenerate();
                        console.log("generate");
                    }
                }


                // this.createQr({ id_mesin: this.getDeviceId, dbreadonly: this.$route.query.readonly });
                // this.isConnected = false;
                //
                // this.countDown();
            },
            showMultiModal() {
                let query = {
                    id_perangkat: `${this.getDeviceId}`,
                    via: 'website',
                    readonly: this.$route.query.readonly

                }
                this.$router.push({
                    name: "wa_autosender.connect_perangkat.confirm_wa_multiple",
                    query
                });

            },

            doGenerate() {
                this.isConnected = false;
                this.generate = false;
                this.countDown();
                this.loadQr();
            },
            countDown() {
                let countTime = new Date().getTime() + 1 * 30000;
                let that = this;
                let x = setInterval(function () {
                    let distance = countTime - new Date().getTime();

                    let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                    let seconds = Math.floor((distance % (1000 * 60)) / 1000);
                    let countDown = document.getElementById("countdown-qr");
                    if (countDown) {
                        countDown.innerHTML = `${minutes}:${seconds}`;
                    }

                    if (distance < 0) {
                        that.generate = true;
                        if (countDown) {
                            countDown.innerHTML = "0:0";
                        }
                        clearInterval(x);
                    }

                    if (that.qr || !countDown) {
                        clearInterval(x);
                    }
                }, 1000);
            },
            async loadQr() {
                this.isNeedReload = false;
                this.isOnSyncData = false;
                this.eMsg = "";
                await this.setQr("");
                await this.setFetching(true);
                await this.createQr({
                    id_mesin: this.getDeviceId,
                    multiperangkat: 1,
                    dbreadonly: this.$route.query.readonly
                });
            },
        },
    };
</script>
<style scoped>
    .web-view {
        background-color: #f2f5f7;
    }

    .wa-instruction-web {
        display: none;
    }

    .logo-smartlnk {
        display: none;
    }

    .m-t--50 {
        margin-top: -50px;
    }

    .wa-qrcode {
        background: #ffffff;
        margin-right: 20px;
        margin-left: 20px;
        margin-top: 16px;
        padding: 16px 10px;
        box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
        border-radius: 4px;
    }

    .wa-qrcode .qr-head {
        text-align: center;
    }

    .wa-qrcode .qr-head label {
        display: block;
    }

    .wa-qrcode .qr-body {
        display: flex;
        justify-content: center;
    }

    .connected-device {
        background: #ffffff;
        height: 148px;
        margin: 30px;
        margin-top: 25vh;
        min-height: 300px;
    }

    @media (min-width: 780px) {
        .web-view {
            background: #ffffff;
            margin: auto;
            width: 90%;
            display: flex;
            align-items: center;
        }

        .wa-instruction-m {
            display: none;
        }

        .wa-instruction-web {
            display: block;
            border-left: 1px solid #ededed;
            min-height: 300px;
        }

        .logo-smartlnk {
            display: block;
            text-align: center;
            margin-top: 50px;
            margin-bottom: 20px;
        }

        .wa-qrcode {
            width: 330px;
            box-shadow: unset;
        }

        .connected-device {
            margin: auto;
        }
    }

    @media (min-width: 1000px) {
        .connected-device {
            margin: auto;
        }

        .web-view {
            width: 70%;
        }
    }

    .img-whatsapp-multi {
        max-width: 300px;
    }

</style>
